<span class="bubble block {{ bubbleColor }} {{ class }}"
      [style.width]="bubbleSize"
      [style.height]="bubbleSize"
></span>
